import { Component, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-home-layout',
    template: `
    <div class="d-flex vh-100 overflow-hidden theme-bg-color position-relative">
    
      @if (isSidebarOpen) {
        <div class="offcanvas-backdrop fade show d-lg-none"
          (click)="closeSidebar()">
        </div>
      }
    
      <div class="offcanvas-lg offcanvas-start sidebar-wrapper theme-bg-color"
        [class.show]="isSidebarOpen" tabindex="-1">
    
        <div class="offcanvas-header d-lg-none border-bottom px-3 py-2 d-flex justify-content-between align-items-center">
          <h5 class="offcanvas-title m-0">Menu</h5>
          <button type="button" class="btn-close" aria-label="Close" (click)="closeSidebar()"></button>
        </div>
    
        <div class="offcanvas-body p-0 h-100">
          <app-sidebar class="w-100"></app-sidebar>
        </div>
      </div>
    
      <div class="d-flex flex-column flex-grow-1 overflow-hidden min-width-0 position-relative">
    
        <header class="header-container d-flex align-items-center">
          <button class="btn btn-sm btn-outline-dark d-lg-none ms-1 me-3" type="button" (click)="toggleSidebar()">
            ☰
          </button>
    
          <div class="flex-grow-1">
            <app-header></app-header>
          </div>
        </header>
    
        <main class="content-main flex-grow-1 overflow-auto theme-body-bg-color">
          <div class="router-container">
            <router-outlet></router-outlet>
          </div>
        </main>
        <footer class="footer-container overflow-hidden">
          <app-footer></app-footer>
        </footer>
      </div>
    
    </div>
    
    <app-download-progress></app-download-progress>
    `,
    styles: [`
    :host {
      display: block;
      --sidebar-width: 240px; 
      --header-height: 40px;  
      --footer-height: 40px;
    }

    .sidebar-wrapper {
      width: var(--sidebar-width);
      z-index: 1050;
      transition: transform 0.3s ease-in-out;
      flex-shrink: 0;
      overflow-y: auto;
    }

    @media (max-width: 991.98px) {
      :host {
        --footer-height: 25px;
      }

      .footer-container {
        left: 10px !important;
        right: 10px !important;
      }
      
      .content-main {
        padding: 0;
      }

      .router-container {
        padding-left: 5px;
        padding-right: 5px;
      }
    }

    .header-container {
      height: var(--header-height);
      flex-shrink: 0;
      z-index: 999;
    }

    .footer-container {
      position: absolute;
      bottom: 0;
      left: 50px;
      right: 40px;
      height: var(--footer-height);
      z-index: 100;
      border-radius: 8px;
    }

    .content-main {
      flex: 1;
      overflow-y: auto;
      background-color: var(--theme-body-bg-color, transparent);
      position: relative;
    }

    .router-container {
      min-height: 100%;
      padding-bottom: calc(var(--footer-height) + 20px);
    }

    .offcanvas-backdrop {
      z-index: 1040;
    }
    
    .min-width-0 {
      min-width: 0;
    }
  `],
    standalone: false
})
export class HomeLayoutComponent implements OnDestroy {

  isSidebarOpen = false;
  private readonly routerSubscription: Subscription;

  constructor(private readonly router: Router) {
    this.routerSubscription = this.router.events.pipe(
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.closeSidebar();
    });
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}